export enum ActionTypes {
  UPDATE_INTEGRATION = '[UPDATE_INTEGRATION] Update integration',
  UPDATE_INTEGRATION_SUCCESS = '[UPDATE_INTEGRATION] Update integration success',
  UPDATE_INTEGRATION_FAILURE = '[UPDATE_INTEGRATION] Update integration failure',
}
